module.exports = __webpack_public_path__ + "c35c4c7803529d298d88c805d2ff0f87.webp";